import { useCallback, useEffect, useState } from "react";
import { ChevronDown, ChevronRight, History } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/KpiCard";
import { DeplacementsPanel } from "@/components/DeplacementsPanel";
import { api, errMsg } from "@/lib/api";

const dateFr = (iso) => new Date(iso).toLocaleString("fr-CA", { dateStyle: "long", timeStyle: "short" });

const Ligne = ({ r, ouvert, onVoir, onClose, onChange }) => (
  <li className="py-3" data-testid={`reimport-${r.id}`}>
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div className="flex items-start gap-2 text-sm">
        <History className="mt-0.5 h-4 w-4 shrink-0 text-sky-700" />
        <div>
          <p className="font-medium text-slate-900" data-testid={`reimport-${r.id}-date`}>{dateFr(r.created_at)}{r.dossier ? ` · dossier « ${r.dossier} »` : ""}</p>
          <p className="text-xs text-slate-500" data-testid={`reimport-${r.id}-resume`}>
            {r.nb ? `${r.nb} réservation(s) déplacée(s)` : "0 déplacement : tout était au bon logement"}{r.nb_annules ? ` · ${r.nb_annules} annulé(s)` : ""}
          </p>
        </div>
      </div>
      <Button size="sm" variant="outline" className="h-7 bg-white text-xs" onClick={() => onVoir(r.id)} data-testid={`reimport-${r.id}-voir`}>
        {ouvert ? <ChevronDown className="mr-1 h-3 w-3" /> : <ChevronRight className="mr-1 h-3 w-3" />}{ouvert ? "Masquer" : "Voir le détail"}
      </Button>
    </div>
    {ouvert && <DeplacementsPanel reimport={ouvert} titre={`Réimport du ${dateFr(r.created_at)}`} onClose={onClose} onChange={onChange} testId={`reimport-${r.id}-detail`} />}
  </li>
);

export const HistoriqueReimports = ({ cle, onChange }) => {
  const [liste, setListe] = useState([]);
  const [ouvert, setOuvert] = useState(null);
  const charger = useCallback(() => api.get("/reimports").then((r) => setListe(r.data)).catch(() => {}), []);
  useEffect(() => { charger(); }, [charger, cle]);
  if (!liste.length) return null;
  const voir = async (id) => {
    if (ouvert?.id === id) { setOuvert(null); return; }
    try { setOuvert((await api.get(`/reimports/${id}`)).data); } catch (e) { toast.error(errMsg(e)); }
  };
  const change = () => { charger(); onChange?.(); };
  return (
    <Panel title="Historique des réimports" className="mt-6" testId="reimports-historique">
      <ul className="-my-3 max-h-[36rem] divide-y divide-slate-100 overflow-y-auto pr-1">
        {liste.map((r) => <Ligne key={r.id} r={r} ouvert={ouvert?.id === r.id ? ouvert : null} onVoir={voir} onClose={() => setOuvert(null)} onChange={change} />)}
      </ul>
    </Panel>
  );
};
